var m = require('mithril');

var Row = {
    view: ({ attrs: { label, text, link, onclick } }) => {
        var cells = [
            m('.table__cell.table__cell_left',
                m('p', label)
            ),
            m('.table__cell.table__cell_right',
                m('p', text)
            )
        ];

        if (link) {
            return m('.table__row', { onclick },
                m('a', { href: link, target: '_blank' },
                    cells
                )
            )
        } else {
            return m('.table__row', { onclick }, cells);
        }
    }
}

module.exports = Row;


// WEBPACK FOOTER //
// ./js/components/TableRow.js